<template>
    <div class="exportPrelevement">
        <el-select v-model="bonSelected" placeholder="Choisir le bon" clearable>
            <el-option v-for="item in dataExport" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
        <el-button v-if="bonSelected!=''" @click.native.prevent="getExportPrelevement" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="Téléchargement en cours..." type="warning" size="small" class="btnGenerateCsv">
            <i class="fas fa-file-csv iconOperationCsv"> Générer l'export</i>
        </el-button>
        <el-button v-else disabled type="warning" size="small" class="btnGenerateCsv">
            <i class="fas fa-file-csv iconOperationCsv"> Générer l'export</i>
        </el-button>
    </div>
</template>

<script>
var moment = require('moment');
import script from '../../../../script/script.js';
import scriptComptabilite from '../../../../script/script_comptabilite';
export default {
	data () {
		return {
			bonSelected:'',
			dataExport:[],
            fullscreenLoading:false,
            data:[]
		}
	},
	methods: {
        getPrelevementBons: scriptComptabilite.getPrelevementBons,
        generateExportBons: scriptComptabilite.generateExportBons,
        async getExportPrelevement(){
            this.fullscreenLoading = true
            let bons = this.data.filter(bon => bon.rowid == this.bonSelected)
            let dateCred = moment(bons[0].date_credit).format('L')
            let nomBon = bons[0].ref
            await this.generateExportBons(this.bonSelected, dateCred,nomBon)
            this.fullscreenLoading = false
        }
    },
	computed:{
	},
	mounted: function(){
        this.getPrelevementBons()
	}
}
</script>

<style>
.btnGenerateCsv{
	margin-left: .5em;
}

.exportPrelevement{
    padding: 0.5em;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
}
</style>